import React, { useState } from 'react';
import { EntityPickerInput } from './EntityPickerInput';
import { EntityPickerModal } from './EntityPickerModal';

/**
 * Generic EntityPickerField
 * 
 * Reusable field component that combines input + modal for any entity type
 * 
 * @param {Object} config - Configuration object (injected by wrapper)
 * @param {string} entityId - Selected entity ID (prop name varies per wrapper)
 * @param {string} displayValue - Text to display in input
 * @param {Function} onSelect - Callback when entity is selected
 * @param {Function} onClear - Callback when selection is cleared
 */
export function EntityPickerField({
	config,
	label,
	isRequired = true,
	entityId,
	displayValue = "",
	onSelect,
	onClear,
	error = false,
	errorMessage = "",
	placeholder,
	allowClear = true,
	viewMode = false,
	disabled = false,
  allowAll = false,
}) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	
	// Use config placeholder if not provided
	const finalPlaceholder = placeholder || config.placeholder || "--Select--";
	
	// Clear display value if no entity selected
	const finalDisplayValue = entityId ? displayValue : '';

	const handleSelect = (entity) => {
		onSelect(entity);
		setIsModalOpen(false);
	};

	const handleClear = () => {
		if (onClear) onClear();
	};

	const handleOpenModal = () => {
		if (!disabled) {
			setIsModalOpen(true);
		}
	};

	return (
		<>
			<EntityPickerInput
				label={label}
				isRequired={isRequired}
				value={finalDisplayValue}
				placeholder={finalPlaceholder}
				error={error}
				errorMessage={errorMessage}
				hasSelection={!!entityId}
				allowClear={allowClear}
				onSelectClick={handleOpenModal}
				onClearClick={handleClear}
				viewMode={viewMode}
				disabled={disabled}
        allowAll={allowAll}
			/>

			{!viewMode && !disabled && (
				<EntityPickerModal
					isOpen={isModalOpen}
					onClose={() => setIsModalOpen(false)}
					setData={handleSelect}
					config={config}
				/>
			)}
		</>
	);
}